/** Tool logo stems under `public/assets/imgs/tools/{id}.svg`. */
export type CcServiceDirectoryBrandIconId =
  | "billy"
  | "dinero"
  | "e-conomic"
  | "exact-online"
  | "fatture-in-cloud"
  | "fortnox"
  | "hubspot"
  | "make"
  | "n8n"
  | "pennylane"
  | "procountor"
  | "quickbooks"
  | "salesforce"
  | "sap"
  | "shopify"
  | "snelstart"
  | "visma"
  | "tripletex"
  | "xero"
  | "zapier";

const SERVICE_DIRECTORY_BRAND_ICON_IDS: CcServiceDirectoryBrandIconId[] = [
  "billy",
  "dinero",
  "e-conomic",
  "exact-online",
  "fatture-in-cloud",
  "fortnox",
  "hubspot",
  "make",
  "n8n",
  "pennylane",
  "procountor",
  "quickbooks",
  "salesforce",
  "sap",
  "shopify",
  "snelstart",
  "visma",
  "tripletex",
  "xero",
  "zapier",
];

const BRAND_ICON_SET = new Set<string>(SERVICE_DIRECTORY_BRAND_ICON_IDS);

export function isServiceDirectoryBrandIconId(
  value: string,
): value is CcServiceDirectoryBrandIconId {
  return BRAND_ICON_SET.has(value);
}

export function getServiceDirectoryBrandLogoSrc(
  brand: CcServiceDirectoryBrandIconId,
): string {
  return `/assets/imgs/tools/${brand}.svg`;
}
